var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.8519887mm",
    height: "3.2260644mm",
    viewBox: "0 0 1.8519887 3.2260644",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-100.37162,-57.261968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4532",
    transform: "matrix(0.26458333,0,0,0.26458333,100.37162,57.261968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4518",
    d: "M 5.188,1 H 0 V 12.193 L 6.467,3.568 C 7.526,2.156 6.958,1 5.188,1 Z",
    style: {
      opacity: 0.12999998
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4520",
    d: "M 5.188,0 H 0 V 11.193 L 6.467,2.568 C 7.526,1.156 6.958,0 5.188,0 Z",
    style: {
      fill: "#f7bfaa",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatArrowRight);
export default __webpack_public_path__ + "static/media/chat_arrow_right.43b845e71b57b190c9bad2e57cd10e8d.svg";
export { ForwardRef as ReactComponent };